/* eslint-disable @typescript-eslint/no-use-before-define */
import React from "react";
import FrontHeader from "../shared/FrontHeader/FrontHeader";
import FrontFooter from "../shared/FrontFooter/FrontFooter";
import BannerHomepage from "./BannerHomepage";
import NosRealisationsSection from "./NosRealisationsSection";
import BestSellersSection from "./BestSellersSection";
import NosProduitsSection from "./NosProduitsSection";
import CategoryCardAsBestSeller from "./CategoryCardAsBestSeller";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import Fade from "react-reveal/Fade";
import StarRatingComponent from "react-star-rating-component";
import { NavLink, useSearchParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Empty from "../../assets/images/appImages/category.png";
import { getImage, truncateCaractere, formatCurrency, createMarkup } from "../../utils/Utils";
import { useLazyFavoriteByUserQuery } from "../../utils/api/favories/favorie.api";
import { useGetAllCategoryListQuery } from "../../utils/api/category/category.api";
import type { Category } from "../../utils/api/category/category.type";
import { ApiBaseUrl } from "../../utils/http";
import axios from "axios";
import { useAppSelector, useAppDispatch } from "../../redux/hook";
import Swal from "sweetalert2";
import { Color } from "../../utils/theme";
import { useGetVendeurByApiKeyQuery } from "../../utils/api/product/product.api";
import { VendeurApikey } from "../../utils/http";
import { AppLocalStorage } from "../../utils/storage";
import { onSetUserToken } from "../../redux/slice/User.slice";

const PUBLIC_URL = process.env.PUBLIC_URL || "";
const CARRELAGE_EXCEPTION_IMG = `${PUBLIC_URL}/${encodeURIComponent("Group 1000004776.png")}`;
const CARRELAGE_EXCEPTION_IMG_2 = `${PUBLIC_URL}/${encodeURIComponent("Group 1000004777.png")}`;
const CATALOGUE_ADHESIFS_PDF = `${PUBLIC_URL}/PDF/${encodeURIComponent(
  "Catalogue Adhésifs Edition Christianisme.pdf"
)}`;

const carrelageExceptionRows = [
  {
    imageSrc: CARRELAGE_EXCEPTION_IMG,
    imageAlt: "Édition Christianisme — carreaux adhésifs",
    title: "CARRELAGE ADHÉSIF",
    paragraphs: [
      "Carrelage mural adhésif résistant à la chaleur, l'humidité, la moisissure et au jaunissement. Très simple d'utilisation : il vous suffit de bien nettoyer la surface murale ou de mobilier à recouvrir et de coller les carreaux adhésifs de votre choix pour relooker les murs de votre salle de bain ou cuisine, ou encore vos contremarches d'escaliers.",
    ],
  },
  {
    imageSrc: CARRELAGE_EXCEPTION_IMG_2,
    imageAlt: "Carrelage d'exception — ambiance salle de bain grand format",
    title: "CARRELAGE PORCELAINE",
    titleTone: "navy" as const,
    paragraphs: [
      "Découvrez l'élégance brute de nos carreaux en porcelaine d'exception, où la finesse du design rencontre une résistance inégalée. Sélectionnées pour leur caractère unique et leur finition prestigieuse, nos collections transforment vos sols et murs en véritables signatures esthétiques.",
      "Avec KAZAMANSA, offrez à vos espaces le luxe d'un matériau durable au raffinement intemporel.",
    ],
  },
];

/** URL affichable pour getImage (évite erreurs si le backend renvoie un type inattendu). */
function categoryListImageSrc(item: Pick<Category, "images">): string {
  const raw = item?.images;
  if (raw == null || raw === "") return Empty;
  if (typeof raw !== "string") return Empty;
  return getImage(raw);
}

const HomePage = () => {
  const dispatch = useAppDispatch();
  const Remember = AppLocalStorage.getItem("remember");
  const UserRemember: any = AppLocalStorage.getItem("user");

  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  const { data: categories, isLoading: isLoadingCategorie } =
    useGetAllCategoryListQuery();
  React.useEffect(() => {
    if (status == "success") {
      Swal.fire({
        icon: "success",
        title: `Paiement effectué avec succès!`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 3000,
      });
    }
    if (status == "error") {
      Swal.fire({
        icon: "error",
        title: "Erreur est survenue lors du paiement !",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  }, [status]);

  React.useEffect(() => {
    if (Remember) {
      dispatch(
        onSetUserToken({
          user: UserRemember?.user,
          token: UserRemember?.token,
        })
      );
    }
  }, [Remember]);

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content">
        <BannerHomepage />
        <div className="container-easy-market mb-5">

          <div className="container-category-display-mobile px-lg-3 section-notre-carrelage">
            <div className="content-title-home-page pb-5">
              <div className="title-home-page-container">
                <Fade bottom>
                  <h3 className="title-home-page-theme text-center">
                    NOTRE CARRELAGE
                  </h3>
                </Fade>
              </div>
            </div>
            <div className="container-grid-categories">
              {isLoadingCategorie ? (
                <div
                  className="best-sellers-section-grid section-notre-carrelage-grid"
                  aria-busy="true"
                  role="list"
                >
                  {Array.from({ length: 8 }).map((_, i) => (
                    <div
                      key={`cat-skel-${i}`}
                      className="best-sellers-section-grid-item"
                      role="listitem"
                    >
                      <div className="best-seller-card best-seller-card--category best-seller-card--skeleton">
                        <Skeleton height={220} className="mb-0" />
                        <div className="p-3">
                          <Skeleton height={22} className="mb-0" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  className="best-sellers-section-grid section-notre-carrelage-grid"
                  role="list"
                >
                  {categories?.results?.map((item) => (
                    <div
                      key={item.id}
                      className="best-sellers-section-grid-item"
                      role="listitem"
                    >
                      <CategoryCardAsBestSeller
                        item={item}
                        imageSrc={categoryListImageSrc(item)}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <section
            className="section-carrelage-exception px-lg-3"
            aria-labelledby="carrelage-exception-heading"
          >
            <Fade bottom>
              <h2
                id="carrelage-exception-heading"
                className="carrelage-exception-title text-center"
              >
                CARRELAGE D&apos;EXCEPTION
              </h2>
            </Fade>
            {carrelageExceptionRows.map((row, index) => (
              <div
                key={row.imageSrc}
                className={
                  index > 0
                    ? "carrelage-exception-grid carrelage-exception-grid--below"
                    : "carrelage-exception-grid"
                }
              >
                <div className="carrelage-exception-visual">
                  <img
                    src={row.imageSrc}
                    alt={row.imageAlt}
                    loading="lazy"
                    className="carrelage-exception-image"
                  />
                </div>
                <div className="carrelage-exception-content">
                  <h3
                    className={
                      row.titleTone === "navy"
                        ? "carrelage-exception-subtitle carrelage-exception-subtitle--navy"
                        : "carrelage-exception-subtitle"
                    }
                  >
                    {row.title}
                  </h3>
                  {row.paragraphs.map((paragraph, pIndex) => (
                    <p
                      key={pIndex}
                      className="carrelage-exception-text"
                    >
                      {paragraph}
                    </p>
                  ))}
                  {index === 0 && (
                    <div className="carrelage-exception-actions">
                      <a
                        href={CATALOGUE_ADHESIFS_PDF}
                        className="carrelage-exception-btn-catalogue"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        VOIR LE CATALOGUE
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </section>

          <NosRealisationsSection />

          <BestSellersSection />
          <NosProduitsSection />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default HomePage;

export const ProductItem = ({ item }: { item: any }) => {
  const { user, token } = useAppSelector((s) => s?.user);
  const Vendeur = getVendeur();

  const imgProd =
    item?.type == "taille_unique"
      ? item?.images[0]?.image
      : item?.variations && item?.variations[0]?.images
        ? item?.variations[0]?.images[0]?.image
        : null;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const [findBySlug, { data, isLoading }] = useLazyFavoriteByUserQuery();

  React.useEffect(() => {
    if (user?.slug) {
      findBySlug(user?.slug as string);
    }
  }, [user]);

  const handleAddFavoris = (id) => {
    let favorie = data?.find((x) => x?.produit?.id == id);

    let fd = new FormData();

    fd.append("user", user?.id);
    fd.append("produit", id);

    if (favorie) {
      axios
        .delete(ApiBaseUrl + `/api/favoris/${favorie?.slug}`, config)
        .then((response) => {
          findBySlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    } else {
      axios
        .post(ApiBaseUrl + "/api/favoris/", fd, config)
        .then((response) => {
          findBySlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    }
  };

  const isFavorite = (id) => {
    let favorie = data?.find((x) => x?.produit?.id == id);

    if (favorie) {
      return true;
    } else {
      return false;
    }
  };

  const onToggleFavorite = (id) => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: `Veuilliez vous connecter pour ajouter un produit au favoris .`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 6000,
      });
    } else {
      handleAddFavoris(id);
    }
  };

  return (
    <Fade bottom>
      <div className="product-item-container" style={{ flexGrow: 1 }}>
        <NavLink
          to={`/produit/${item?.slug}`}
          state={item}
          className="no-link w-100"
        >
          {item?.new === true ? (
            <span className="statut-product-item">Nouveau</span>
          ) : item?.stock == 0 ? (
            <span className="statut-product-rupture">Rupture de stock</span>
          ) : (
            ""
          )}
          {(item?.categorie?.promotion?.is_active ||
            item?.sous_categorie?.promotion?.is_active ||
            item?.promotion?.is_active) && (
              <span className="statut-product-item">
                Promo -
                {item?.categorie?.promotion?.taux ||
                  item?.sous_categorie?.promotion?.taux ||
                  item?.promotion?.taux}
                %
              </span>
            )}

          <div className="content-img-product-item">
            <img
              loading="lazy"
              src={imgProd ? getImage(imgProd) : Empty}
              alt={item?.nom}
              className="img-product-item"
            />
          </div>
          <div className="container-body-product-item">
            <div className="content-element-body-product-item">
              <p className="name-product-item my-2 reduce_hg">
                {window.innerWidth < 720
                  ? truncateCaractere(item?.nom, 39)
                  : truncateCaractere(item?.nom, 72)}
              </p>
              <div className="content-price-product">
                {item?.categorie?.promotion?.is_active ||
                  item?.sous_categorie?.promotion?.is_active ||
                  item?.promotion?.is_active ? (
                  <>
                    <span className="price-product-item-promo pb-3">
                      {formatCurrency(
                        item?.prix -
                        (item?.prix *
                          (item?.categorie?.promotion?.taux ||
                            item?.sous_categorie?.promotion?.taux ||
                            item?.promotion?.taux)) /
                        100,
                        Vendeur?.devise
                      )}{" "}
                    </span>
                    <span className="price-product-item-bare pb-3">
                      {formatCurrency(item?.prix, Vendeur?.devise)}
                    </span>
                  </>
                ) : (
                  <p className="price-product-item d-flex">
                    {formatCurrency(item?.prix, Vendeur?.devise)}
                  </p>
                )}
              </div>
            </div>
            <div className="container-cta-chat-produit">
              {item?.stock > 0 ? (
                <div className="content-btn-achat-produit w-100">
                  <NavLink
                    to={`/produit/${item?.slug}`}
                    className="btn btn-theme w-100"
                  >
                    Acheter
                  </NavLink>
                </div>
              ) : (
                <div className="content-btn-achat-produit w-100">
                  <button className="btn btn-theme-outline w-100 disabled">
                    Acheter
                  </button>
                </div>
              )}
              {/* <div className="content-btn-add-to-panier">
                {item.rupture === false ? (
                <button 
                  className={`
                    btn btn-theme-outline ${isAddedToCart ? 'added_to_card' : ''}
                  `}
                  onClick={() => setIsAddedToCart(!isAddedToCart)}
                >
                  {isAddedToCart ? <BsCartCheck /> : <FiShoppingCart />}
                </button>
                 ) : (
                  <button 
                  className="btn btn-theme-outline disabled"
                >
                  {isAddedToCart ? <BsCartCheck /> : <FiShoppingCart />}
                </button>
                 )}
              </div> */}
            </div>
          </div>
        </NavLink>
        <button
          disabled={isLoading}
          className="btn icon-fav-product"
          id={item?.id}
          aria-label="Ajouter au favoris"
          onClick={() => onToggleFavorite(item?.id)}
        >
          {isFavorite(item?.id) ? (
            <AiFillHeart style={{ color: "#E58924" }} />
          ) : (
            <AiOutlineHeart />
          )}
        </button>
      </div>
    </Fade>
  );
};

export const LargeProductItem = ({ item }: { item: any }) => {
  const { user, token } = useAppSelector((s) => s?.user);
  const Vendeur = getVendeur();

  const imgProd =
    item?.type == "taille_unique"
      ? item?.images[0]?.image
      : item?.variations && item?.variations[0]?.images
        ? item?.variations[0]?.images[0]?.image
        : null;

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const [findBySlug, { data, isLoading }] = useLazyFavoriteByUserQuery();

  React.useEffect(() => {
    if (user?.slug) {
      findBySlug(user?.slug as string);
    }
  }, [user]);

  const handleAddFavoris = (id) => {
    let favorie = data?.find((x) => x?.produit?.id == id);

    let fd = new FormData();

    fd.append("user", user?.id);
    fd.append("produit", id);

    if (favorie) {
      axios
        .delete(ApiBaseUrl + `/api/favoris/${favorie?.slug}`, config)
        .then((response) => {
          findBySlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    } else {
      axios
        .post(ApiBaseUrl + "/api/favoris/", fd, config)
        .then((response) => {
          findBySlug(user?.slug as string);
        })
        .catch((error) => {
          console.error(`Error: ${error}`);
        });
    }
  };

  const isFavorite = (id) => {
    let favorie = data?.find((x) => x?.produit?.id == id);

    if (favorie) {
      return true;
    } else {
      return false;
    }
  };

  const onToggleFavorite = (id) => {
    if (!user?.slug) {
      Swal.fire({
        icon: "info",
        title: `Veuilliez vous connecter pour ajouter un produit au favoris .`,
        iconColor: Color.success,
        showConfirmButton: false,
        timer: 6000,
      });
    } else {
      handleAddFavoris(id);
    }
  };

  return (
    <Fade bottom>
      <div className="product-item-container large-product-item" style={{ flexGrow: 1 }}>
        <NavLink
          to={`/produit/${item?.slug}`}
          state={item}
          className="no-link w-100"
        >
          {item?.new === true ? (
            <span className="statut-product-item">Nouveau</span>
          ) : item?.stock == 0 ? (
            <span className="statut-product-rupture">Rupture de stock</span>
          ) : (
            ""
          )}
          {(item?.categorie?.promotion?.is_active ||
            item?.sous_categorie?.promotion?.is_active ||
            item?.promotion?.is_active) && (
              <span className="statut-product-item">
                Promo -
                {item?.categorie?.promotion?.taux ||
                  item?.sous_categorie?.promotion?.taux ||
                  item?.promotion?.taux}
                %
              </span>
            )}
          <div className="row product-row">
            <div className="col-lg-5 mb-3 col-wrapper">
              <div className="content-img-product-item">
                <img
                  loading="lazy"
                  src={imgProd ? getImage(imgProd) : Empty}
                  alt={item?.nom}
                  className="img-product-item"
                />
              </div>
            </div>
            <div className="col-lg-7 mb-3 col-wrapper">
              <div className="container-body-product-item">
                <div className="content-element-body-product-item">
                  <p className="name-product-item my-2 reduce_hg">
                    {window.innerWidth < 720
                      ? truncateCaractere(item?.nom, 39)
                      : truncateCaractere(item?.nom, 72)}
                  </p>
                  <div className="d-none d-lg-block">
                    <p
                      className="pb-2 text-describe-product-item-detail"
                      dangerouslySetInnerHTML={createMarkup(item?.description, false, 150)}
                    />
                  </div>
                  <div className="content-price-product">
                    {item?.categorie?.promotion?.is_active ||
                      item?.sous_categorie?.promotion?.is_active ||
                      item?.promotion?.is_active ? (
                      <>
                        <span className="price-product-item-promo pb-3">
                          {formatCurrency(
                            item?.prix -
                            (item?.prix *
                              (item?.categorie?.promotion?.taux ||
                                item?.sous_categorie?.promotion?.taux ||
                                item?.promotion?.taux)) /
                            100,
                            Vendeur?.devise
                          )}{" "}
                        </span>
                        <span className="price-product-item-bare pb-3">
                          {formatCurrency(item?.prix, Vendeur?.devise)}
                        </span>
                      </>
                    ) : (
                      <p className="price-product-item d-flex">
                        {formatCurrency(item?.prix, Vendeur?.devise)}
                      </p>
                    )}
                  </div>
                </div>
                <div className="container-cta-chat-produit">
                  {item?.stock > 0 ? (
                    <div className="mt-1 container-btn-accueil w-100">
                      <NavLink
                        className="btn btn-title-home-page"
                        to={`/produit/${item?.slug}`}
                      >
                        Je m'inscris
                      </NavLink>
                    </div>
                  ) : (
                    <div className="mt-1 container-btn-accueil w-100">
                      <button className="btn btn-title-home-page disabled">
                        Je m'inscris
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </NavLink>
        <button
          disabled={isLoading}
          className="btn icon-fav-product"
          id={item?.id}
          aria-label="Ajouter au favoris"
          onClick={() => onToggleFavorite(item?.id)}
        >
          {isFavorite(item?.id) ? (
            <AiFillHeart style={{ color: "#E58924" }} />
          ) : (
            <AiOutlineHeart />
          )}
        </button>
      </div>
    </Fade>
  );
};

export const ProductItemSkeleton = () => {
  return (
    <>
      {Array(12)
        .fill(12)
        .map((item, i) => (
          <div className="col-product-item" key={i}>
            <div
              className="product-item-container"
              style={{ border: "1px solid #ebebeb", textAlign: "center" }}
            >
              <div className="content-img-product-item">
                <Skeleton className="img-product-item" />
              </div>
              <div className="content-btn-buy-product-item py-3">
                <Skeleton
                  className="btn btn-buy-product-item bg-transparent"
                  width={`50%`}
                />
              </div>
              <div className="text-center">
                <Skeleton
                  className="price-product-item"
                  width={`60%`}
                  height={20}
                />
                <Skeleton
                  className="name-prduct fs-15"
                  width={`70%`}
                  height={15}
                />
                <div className="content-rate-product">
                  <StarRatingComponent
                    name="rate2"
                    starCount={5}
                    value={0}
                    starColor="#000000"
                    emptyStarColor="#D4D6D5"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export const getVendeur = () => {
  const { data: vendeur } = useGetVendeurByApiKeyQuery(VendeurApikey);

  return vendeur;
};